/*
 * Created by jmeo at 2021-05-11
 * FileName: ImgLabel.tsx
 */

import React from "react";

type ImgLabelProps = {
    label?: string
    type: 'capture' | 'normal'
}

export default function (props: ImgLabelProps) {
    return (
        <div className="cfImageLabel">
            <div className={props.type == 'capture' ? 'capture' : 'normal'}/>
            <div className="label">{props.label}</div>
        </div>
    )
}
